import axios from 'axios'

// 安全配置：使用环境变量隐藏服务器地址
const baseURL = process.env.VUE_APP_API_BASE_URL || '';

// 创建axios实例
const request = axios.create({
  baseURL:baseURL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'tenant-id':1
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 安全改进：使用更安全的token存储方式
    const token = localStorage.getItem('token')
    if (token) {
      // 验证token格式，防止注入攻击
      if (/^[A-Za-z0-9\-_]+$/.test(token)) {
        config.headers.Authorization = `Bearer ${token}`
      } else {
        console.warn('Invalid token format detected')
        localStorage.removeItem('token')
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data
  },
  error => {
    // 安全改进：生产环境不输出敏感错误信息
    if (error.response) {
      // 服务器返回了错误状态码
      if (process.env.NODE_ENV === 'development') {
        console.error('响应错误:', error.response.status, error.response.data)
      } else {
        console.error('服务器响应错误')
      }
    } else if (error.request) {
      // 请求已经发出，但没有收到响应
      console.error('网络连接错误')
    } else {
      // 其他错误
      console.error('请求配置错误')
    }
    return Promise.reject(error)
  }
)

export default request

